export const VERSION = "2.3.0";
